import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import packageJson from "../package.json";

const isDevelopment = process.env.NODE_ENV === "development";

export const i18nVersion = packageJson.version;

const withVersion = (name: string) =>
  isDevelopment ? name : `${name}-${i18nVersion}`;

export const common = withVersion("common");
export const overview = withVersion("overview");
export const input = withVersion("input");
export const account = withVersion("account");
export const completion = withVersion("completion");
export const organization = withVersion("organization");
export const reduce = withVersion("reduce");
export const report = withVersion("report");
export const economic = withVersion("economic");
export const accessility = withVersion("accessility");
export const financedEmissions = withVersion("financedEmissions");

i18n
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    // public/locales has only en/ and th/
    supportedLngs: ["en", "th"],
    // cut "th-TH" to "th" before matching, or the exact "en" from <html lang> outranks it
    detection: { convertDetectedLanguage: (lng: string) => lng.split("-")[0] },
    ns: [
      common,
      overview,
      input,
      account,
      completion,
      organization,
      reduce,
      report,
      economic,
      accessility,
      financedEmissions,
    ],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    cache: {
      enabled: false, // Disable caching
    },
  });

export default i18n;
